import utils from '@/mixins/utils.js'
import { getQuantidadeTratamentosAtraumaticos } from './functions.js'

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado.
 * @returns {Object}
 */
export function getDataFields(mes = null) {
  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
      },
    },
    Mãe: 'no_mae',
    Atraumáticos: {
      callback: (item) => {
        return getQuantidadeTratamentosAtraumaticos(item, mes)
      },
    },
  }
}

export const infoHtml = ``
